import i18n from '@/i18n'
import { appContext } from '@/utils/common.ts'

export const fetchFromApi = (
  url: string,
  options?: {
    body?: Record<string, unknown>
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
  },
) => {
  return fetch(`${import.meta.env.BACKEND_URL}/bookings/${url}`, {
    body: options?.body ? JSON.stringify(options?.body) : undefined,
    headers: {
      'Accept-Language': i18n.language,
      'Content-Type': 'application/json',
      context: appContext,
    },
    method: options?.method || 'GET',
  })
}
